<pmv-main-content>
    <pmv-main-content-header title="Candidato Convocado" [subtitle]="subtitle">
        <pmv-loading [isLoading]="loading"></pmv-loading>
    </pmv-main-content-header>
</pmv-main-content>

<pmv-main-content-body>

    <div class="container">
        <div class="row" style="margin-bottom: 25px;;">
            <div class="col-xs-12">
                <h2>Informações do Edital/Convocação</h2>
                <span style="display: block;color:#2D699F;">{{editalAnoPss}}</span><br>
                <span>Outras informações relevantes</span>
            </div>
        </div>
        <h1 style="display: block;text-align: center;color:#2D699F;"></h1>
        <br />

        <div class="row">
            <div class="col-md-4 col-xs-1"></div>
            <div class="col-md-4 col-xs-10">

                <a [routerLink]="" (click)="goDadosAdicionais()">
                    <div class="row">
                        <div class="panel" style="border: 1px solid #2f10dd;">
                            <div class="panel-heading" style="color: #ffffff; background-color: #370adb;">
                                <div class="row">
                                    <div class="col-xs-2">
                                        <i class="fa fa-check-square-o fa-3x"></i>
                                    </div>
                                    <div class="col-xs-10 text-right">
                                        <div>
                                            <span style="font-size: 26px">Dados Adicionais</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>

                <a>
                    <div class="row">
                        <div class="panel" style="border: 1px solid #2f10dd;">
                            <div class="panel-heading" style="color: #0303b0; background-color: #ffffff;">
                                <div class="row">
                                    <div class="col-xs-2">
                                        <i class="fa fa-check-square-o fa-3x"></i>
                                    </div>
                                    <div class="col-xs-10 text-right">
                                        <div>
                                            <span style="font-size: 26px">Envio de documentos</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
                <a>
                    <div class="row">
                        <div class="panel" style="border: 1px solid #2f10dd;">
                            <div class="panel-heading" style="color: #0303b0; background-color: #ffffff;">
                                <div class="row">
                                    <div class="col-xs-2">
                                        <i class="fa fa-check-square-o fa-3x"></i>
                                    </div>
                                    <div class="col-xs-10 text-right">
                                        <div>
                                            <span style="font-size: 26px">Agendar Exame Admissional</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>


                <a [routerLink]="" (click)="goDeclaracaoAcumuloCargo()">
                    <div class="row">
                        <div class="panel" style="border: 1px solid #2f10dd;">
                            <div class="panel-heading" style="color: #ffffff; background-color: #370adb;">
                                <div class="row">
                                    <div class="col-xs-2">
                                        <i class="fa fa-check-square-o fa-3x"></i>
                                    </div>
                                    <div class="col-xs-10 text-right">
                                        <div>
                                            <span style="font-size: 26px">Declaração de Acumúlo de Cargo</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>

               
                <a>
                    <div class="row">
                        <div class="panel" style="border: 1px solid #2f10dd;">
                            <div class="panel-heading" style="color: #0303b0; background-color: #ffffff;">
                                <div class="row">
                                    <div class="col-xs-2">
                                        <i class="fa fa-check-square-o fa-3x"></i>
                                    </div>
                                    <div class="col-xs-10 text-right">
                                        <div>
                                            <span style="font-size: 26px">Inicio da Atividade</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>

                <a [routerLink]="" (click)="desistirConvocacao()">
                    <div class="row">
                        <div class="panel" style="border: 1px solid #dd0909c0;">
                            <div class="panel-heading" style="color: #ffffff; background-color: #dd0909;">
                                <div class="row">
                                    <div class="col-xs-2">
                                        <i class="fa fa-times fa-3x"></i>
                                    </div>
                                    <div class="col-xs-10 text-right">
                                        <div>
                                            <span style="font-size: 26px">Desistir da Convocação</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-md-4"></div>
        </div>

        <div class="row">
            <div class="col-md-12" style="margin-top: 15px;">
                <a (click)="voltar()" asp-page="Index" title="Voltar" class="btn btn-warning btn-md pull-left">
                    <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                    Voltar
                </a>
            </div>
        </div>

    </div>
</pmv-main-content-body>



// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/candidato-convocado.component.html